module.exports = __webpack_public_path__ + "static/media/money_heist_cover.f206952e.jpg";